import { LogLevel, PassedInitialConfig } from 'angular-auth-oidc-client';
import { environment } from 'src/environments/environment';

export const authConfig: PassedInitialConfig = {
  config: {
    authority: environment.auth.authority,
    responseType: 'id_token token',
    redirectUrl: environment.FRONT_HOST + '/logged',
    postLogoutRedirectUri: window.location.origin + '/dashboard',
    clientId: 'audaces_insight',
    scope: 'openid profile email offline_access',
    silentRenew: true,
    useRefreshToken: true,
    autoUserInfo: true,
    secureRoutes: [...environment.auth.secureRoutes, environment.API_HOST],
    disableIatOffsetValidation: true,
    // O STS (IdentityServer) reporta `issuer` na raiz (https://login[-dev].audaces.com/)
    // enquanto a `authority` aponta para /core. O angular-auth-oidc-client v20+ passou
    // a validar issuer == authority (o v18 não validava), o que quebrava o login após
    // o upgrade. Este flag restaura o comportamento anterior. Ver JIRA/upgrade-angular
    // (risco R5) e https://github.com/damienbod/angular-auth-oidc-client
    strictIssuerValidationOnWellKnownRetrievalOff: true,
    // Fluxo implícito (responseType 'id_token token') devolve os tokens no HASH
    // (/logged#access_token=...). Na v21 o default de
    // `checkRedirectUrlWhenCheckingIfIsCallback` virou `true`, e essa checagem
    // compara o redirectUrl com a URL atual SEM remover o hash — então o hash
    // com os tokens faz o `isCallbackFromSts` retornar false, o callback nunca é
    // processado (isAuthenticated: false) e o app entra em loop de re-authorize.
    // Desligar restaura o comportamento do v18 (reconhece o callback pela
    // presença dos tokens). Idealmente migrar para code flow + PKCE no futuro.
    checkRedirectUrlWhenCheckingIfIsCallback: false,
    logLevel: LogLevel.Debug,
  },
};
